export function clearPatientFormFields(context) {
    context.dispatch('CLEAR_PATIENT_FORM_FIELDS');
}

export function setPatientFormFields(context, fields) {
    context.dispatch('SET_PATIENT_FORM_FIELDS', fields);
}
